import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { first, firstValueFrom } from 'rxjs';
import { GlobalState } from 'src/app/global.state';
import { environment } from 'src/environments/environment';
import { UserResourceService } from 'src/libs/api-client';
import { SwitchUserRequest, SwitchUserService } from 'src/libs/shared-services/switchuser.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public toggleSwitch : HTMLInputElement | null = null;
  public currentTheme : string | null = null;
  public isLoggedIn : boolean = false;
  public isOnLoginPage: boolean = false;
  public isOnHomePage: boolean = false;
  // public isMobile: boolean = false;

  public showSettings: boolean = false;

  public emulatedUserId: boolean  = false;

  public laststTocVersion : string = "1.0.0";
  public showAcceptToc: boolean = false;
  public acceptedVersions: string[] = [];

  public brand: string = 'map the day'

  constructor(private router: Router, public afAuth: AngularFireAuth, public globalState: GlobalState, 
    private userService: UserResourceService, private globalStateService: GlobalState, private switchUserService: SwitchUserService,
  private toastService: ToastrService)
  {
    // this.isMobile = this.FindisMobile();


  }

  async ngOnInit() {

    if(environment.brand == 'maptheday')
    {
      this.brand = 'Pooper Scoop HQ';
    }
    else{
      this.brand = 'santa schedule';
    }

    // const user = await firstValueFrom(this.afAuth.authState);

    // if (user) {
    //   this.isLoggedIn = true;
    // }
    // else{
    //   this.isLoggedIn = false;
    // }

    this.afAuth.authState.subscribe(async (user) => {
      if (user) {
        this.isLoggedIn = true;
        
        const allowedPages = await this.globalStateService.getAllowedPages();
        if(allowedPages.includes("/settings"))
        {
          this.showSettings = true;
        }

        await this.checkIfUserHasAcceptedTOS();

      }
      else{
        this.isLoggedIn = false;
        this.showAcceptToc = false;
      }

      const emulatedUserIdFound = this.globalStateService.getIsEmulatingUser();
      if(emulatedUserIdFound)
      {
        this.emulatedUserId = true;

      }


    });


    this.router.events.subscribe(event => { 
      if (event instanceof NavigationEnd) { 

        // if we are on the login page
        if(location.pathname.indexOf("login") != -1 || location.pathname.indexOf("zerobusinesses") != -1)
        {
          this.isOnLoginPage = true;
        }
        else{
          this.isOnLoginPage = false;
        }

        if(location.pathname.indexOf("home") == 1 )
        {
          this.isOnHomePage = true;
        }
        else{
          this.isOnHomePage = false;
        }
      } 
    });

    this.toggleSwitch = document.getElementById("testid") as HTMLInputElement;
    this.currentTheme = localStorage.getItem('theme');

    if (this.currentTheme) {
      document.documentElement.setAttribute('data-theme', this.currentTheme);
    
      if (this.currentTheme === 'dark') {
          this.toggleSwitch!.checked = true;
      }
      else{
        this.toggleSwitch!.checked = false;
      }
    }
    else{
      this.currentTheme = 'dark';
      document.documentElement.setAttribute('data-theme', this.currentTheme);
    }

    if(this.toggleSwitch)
    {
      this.toggleSwitch!.addEventListener('change', this.switchTheme, false);
    }


  }

  public async iReviewed()
  {
    await firstValueFrom(this.userService.userResourceAddMyAcceptedTocVersion(environment.tocVersion!!));
    await this.checkIfUserHasAcceptedTOS(true);
  }

  public goToDashboard()
  {
    this.router.navigateByUrl("/global-dashboard");
  }

  public async checkIfUserHasAcceptedTOS(passSessionStorageCheck: boolean = false)
  {
    // we can use session storage as it is cleaed when the user logs out or switches to an emulated user
    const acceptedVersionsSessionStorage = sessionStorage.getItem("acceptedVersions");
    if(acceptedVersionsSessionStorage && passSessionStorageCheck == false) {
      const storedArray : string[] = JSON.parse(acceptedVersionsSessionStorage);
      this.acceptedVersions = storedArray;
    }
    else
    {
      this.acceptedVersions = await firstValueFrom(this.userService.userResourceGetMyAcceptedTocVersions());
      sessionStorage.setItem("acceptedVersions", JSON.stringify(this.acceptedVersions));
    }

    if(!this.acceptedVersions.includes(environment.tocVersion!!))
    {
      this.showAcceptToc = true;
    }
    else{
      this.showAcceptToc = false;
    }
  }

    async clearEmulatedUser()
    {
      const switchUserRequest : SwitchUserRequest= {
        keysToKeep: ["businessid-selected"],
        logOutUser: false
      }
    
      await this.switchUserService.switchUserService(switchUserRequest);
        
      this.toastService.success("Starting to stop emulating the user. We will refresh the page in 5 seconds.");
  
      setTimeout(() => {
        window.location.href = "/global-dashboard";
      }, 3000);
    }

  openMenu()
  {
    this.globalState.switchShowMenuOn();
  }

  // private FindisMobile() {
  //   const minWidth = 768; // Minimum width for desktop devices
  //   return window.innerWidth < minWidth || screen.width < minWidth;
  // }

  switchTheme(e: any) {
    if (e.target.checked) {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
    else {        
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    }    
  }

  goToPage(routeName: string)
  {
    this.router.navigateByUrl(routeName);
  }

  goToLoginPage()
  {
    this.router.navigateByUrl("/login");
  }

  goToSettings()
  {
    this.router.navigateByUrl("/settings");
  }

  async goHome()
  {
         if(await firstValueFrom(this.afAuth.authState))
          {
            this.router.navigateByUrl("/global-dashboard");
          }
          else{
            this.router.navigateByUrl("/home");
          }

  }

  async logout()
  {
    this.globalState.logout();
  }

  openmenu()
  {
    this.globalState.switchShowMenuState();
  }

}
